export default "__VITE_ASSET__DSS5HjMC__"